import classNames from "classnames";
import React from "react";
import { StrategyPicker } from "../strategyPicker/strategyPicker";
import styles from "../../taggingSettings.css";
import { getUrlPlaceholder, mapStrategyToString } from "@fidget/common/utils/urlMappingHelpers";
import { EditInputFieldState } from "@fidget/common/components/form/editInput";
import { ExistingMappingFormType } from "../../types";
import { observer } from "mobx-react";

interface Props {
  form: ExistingMappingFormType;
  isEdited: boolean;
}
export const TaggingStrategy = observer(({ form, isEdited }: Props) => {
  const { matchingStrategy, urlPattern } = form.$;

  const renderFormStrategy = () => {
    if (isEdited) {
      return <StrategyPicker field={matchingStrategy} />;
    }

    return <div className={styles["form-text"]}>{mapStrategyToString(matchingStrategy.$)}</div>;
  };

  const renderFormUrlPattern = () => {
    if (isEdited) {
      return (
        <div>
          <EditInputFieldState
            field={urlPattern}
            className={styles["bottom-input"]}
            readOnly={!isEdited}
            placeholder={getUrlPlaceholder(matchingStrategy.value)}
          />
        </div>
      );
    }

    return (
      <p className={classNames(styles["form-text"], styles["bottom-input"])}>{urlPattern.value}</p>
    );
  };
  return (
    <div className={classNames(styles["url-inputs-container"], styles["inputs-container"])}>
      {renderFormStrategy()}
      {renderFormUrlPattern()}
    </div>
  );
});
